import {
    Directive,
    ElementRef,
    Input, OnChanges, OnDestroy,
    Renderer2,
    SimpleChanges
} from "@angular/core";
import {MainHelper} from "../models/main-helper";
import {BTControl} from "../../stocks/models/b-t-control";

@Directive({
    selector: '[btTooltip]'
})
export class BootstrapTooltipDirective implements OnDestroy, OnChanges{
    constructor(public elementRef: ElementRef, public readonly renderer: Renderer2){
        this.helper = new MainHelper();
        this.renderer.setAttribute(this.elementRef.nativeElement, 'data-toggle', 'tooltip');
        this.renderer.setAttribute(this.elementRef.nativeElement, 'data-html', 'true');
        this.renderer.listen(this.elementRef.nativeElement, 'mouseleave', (event: MouseEvent) =>{
            $(this.elementRef.nativeElement).tooltip('hide');
        });
    }

    @Input('btTooltip')
    set setContainer(container: string){
        if (container){
            return;
        }
        this.renderer.setAttribute(this.elementRef.nativeElement, 'data-container', container)
    }

    @Input('disabled')
    set disabled(val: boolean){
        val && this.hideTooltip();
        val
            ? this.renderer.setAttribute(this.elementRef.nativeElement, 'disabled', 'true')
            : this.renderer.removeAttribute(this.elementRef.nativeElement, 'disabled')
    }

    @Input('title')
    set title(title: string){
        this.removeTooltip();
        this.renderer.removeAttribute(this.elementRef.nativeElement, 'title');
        this._title = title;
        this.helper.wait(() => this.addTooltip());
    }

    @Input('btControl')
    private control?: number

    @Input('btPlacement')
    private placement?: 'auto' | 'left' | 'right' | 'top' | 'bottom'

    @Input('btTest')
    private test?: string

    @Input('btWide')
    private wide?: 'large' | 'very-large'

    private _title: string;
    private helper: MainHelper;

    ngOnChanges(changes: SimpleChanges): void{
        if (changes['control']){
            if (changes['control'].currentValue !== changes['control'].previousValue){
                switch (changes['control'].currentValue){
                    case BTControl.hide: this.removeTooltip(); break;
                    case BTControl.show:
                        this.addTooltip();
                        this.showTooltip();
                        break;
                }
            } else if (changes['control'].currentValue === changes['control'].previousValue && changes['control'].currentValue === BTControl.show){
                this.showTooltip();
            }
        }

    }

    ngOnDestroy(){
        this.removeTooltip();
    }

    private addTooltip = (): void => {
        if (this._title){
            this.test && console.log(this.placement, this.test, this._title, 'this.placement')
            this.renderer.setAttribute(this.elementRef.nativeElement, 'title', this._title);
            this.helper.wait(() => $(this.elementRef.nativeElement).tooltip({
                placement: this.placement ? this.placement : 'auto',
                trigger: 'hover',
                offset: "0, 0",
                template: `<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner ${this.wide ? this.wide : ''}"></div></div>`
            }))
        }
    }

    private removeTooltip = (): void => {
        $(this.elementRef.nativeElement).tooltip('dispose');
    }

    private showTooltip = (): void => {
        this.test && console.log(this.test, 'showTooltip')
        $(this.elementRef.nativeElement).tooltip('show');
    }

    private hideTooltip = (): void => {
        $(this.elementRef.nativeElement).tooltip('hide');
    }


}



// WEBPACK FOOTER //
// ./src/app/shared/directives/bootstrap-tooltip.directive.ts